// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_2787e5dfdf--tooltip--Jsh1z","arrow_tooltip":"_2787e5dfdf--arrow_tooltip--SRU9V","arrow":"_2787e5dfdf--arrow--A4pue"};